var render, staticRenderFns
import script from "./tTable.vue?vue&type=script&lang=js&"
export * from "./tTable.vue?vue&type=script&lang=js&"
import style0 from "./tTable.vue?vue&type=style&index=0&id=eb6c2a4a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb6c2a4a",
  null
  
)

export default component.exports